<!-- <div class="inner">
  <p>Cover template for <a href="https://getbootstrap.com">Bootstrap</a>, by @mdo.</p>
</div> -->
<footer class="container mt-5 py-2">
  <p>&copy; {{appName}} 2017</p>
</footer>